import React from 'react';
import './Persona.css';

const Persona = ({personaData}) => {
    return (
        <div className="profile-column">
          <div className="profile-image-container">
            <img
              src={personaData.photo}
              alt="Healthcare professional"
              className="profile-image"
            />

          </div>

          <div className="profile-info">
            <h2 className="profile-name">{personaData.name}</h2>
            <h3 className="profile-role">{personaData.service}</h3>
            <p className="profile-description">
               {personaData.introduction}
            </p>
          </div>
        </div>
    );
};

export default Persona;
